import ComponentClass from "../utilities/ComponentClass";
import {onWindowResize} from "../utilities/Hooks";
import {mediaBreakpointUp} from "../utilities/MediaBreakpoints";
import {Store} from "../store";

class Burger extends ComponentClass.WebComponent {
    state = {
        visible: false
    }

    #config = {
        bodyClassName: 'menu-opened',
        visibleClassName: 'opened'
    }

    constructor() {
        super();
        const shadow = this.attachShadow({mode: 'open'});
        const slot = document.createElement('slot');
        shadow.append(slot);
    }

    connectedCallback() {
        this.addEventListener('click', () => this.handleBurgerClick(), false);
        this.addEventListener('keyup', (e) => this.handleKeyUp(e), false);
    }

    handleKeyUp(event) {
        if (event.isComposing || event.keyCode === 27) { // escape key
            this.close();
        }
    }

    handleBurgerClick() {
        this.toggle();
    }

    toggle() {
        this.state.visible ? this.close() : this.open();
    }

    open() {
        document.body.classList.add(this.#config.bodyClassName);
        this.classList.add(this.#config.visibleClassName);
        this.setState({visible: true});
        Store.commit({isMenuOpened: this.state.visible})
        this.emit();
    }

    close() {
        document.body.classList.remove(this.#config.bodyClassName);
        this.classList.remove(this.#config.visibleClassName);
        this.setState({visible: false});
        Store.commit({isMenuOpened: this.state.visible})
        this.emit();
    }

    emit() {
        this.dispatchEvent(
            new CustomEvent('menu.toggle', {
                detail: {
                    element: this,
                    state: this.state
                }
            })
        )
    }
}


export default function defineBurgerElement() {
    Burger.define('burger-toggle');
    const burgerElement = document.querySelector('burger-toggle');
    onWindowResize(() => {
        if (mediaBreakpointUp('lg') && burgerElement.state.visible) {
            burgerElement.close();
        }
    });
}
